// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-app-js": () => import("/home/node/app/src/pages/App.js" /* webpackChunkName: "component---src-pages-app-js" */),
  "component---src-pages-index-js": () => import("/home/node/app/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-test-predyspozycji-js": () => import("/home/node/app/src/pages/test-predyspozycji.js" /* webpackChunkName: "component---src-pages-test-predyspozycji-js" */)
}

